import { Link } from 'react-router-dom';

const serviceAreas = [
  { city: 'Palm Coast, FL', slug: 'palm-coast' },
  { city: 'Ormond Beach, FL', slug: 'ormond-beach' },
  { city: 'Daytona Beach, FL', slug: 'daytona-beach' },
  { city: 'Port Orange, FL', slug: 'port-orange' },
  { city: 'New Smyrna Beach, FL', slug: 'new-smyrna-beach' },
  { city: 'Edgewater, FL', slug: 'edgewater' },
];

const quickLinks = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about' },
  { label: 'Services', href: '/services' },
  { label: 'Service Areas', href: '/service-areas' },
  { label: 'Contact', href: '/contact' },
];

const services = [
  { label: 'Fencing', href: '/services#fences' },
  { label: 'Pavers', href: '/services#pavers' },
  { label: 'Landscape Installation', href: '/services#landscape' },
  { label: 'Landscape Lighting', href: '/services#lighting' },
  { label: 'Sheds', href: '/services#sheds' },
];

export default function Footer() {
  return (
    <footer className="bg-white border-t border-stone-dark text-charcoal">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src="https://dippelsoutdoorservices.com/wp-content/uploads/2025/08/logo-303w.webp"
              alt="Dippel's Outdoor Services"
              className="h-12 w-auto object-contain mb-5"
            />
            <p className="text-charcoal-muted text-sm leading-relaxed mb-5">
              Dippel's Outdoor Services delivers premium fencing, pavers, landscape installation, outdoor lighting, and sheds across Florida's beautiful east coast.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.facebook.com/DippelsOutdoorServices"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-stone border border-stone-dark text-charcoal-muted hover:bg-forest hover:text-white hover:border-forest transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a
                href="https://www.google.com/maps/place/Dippel%27s+Outdoor+Services/@28.8555939,-81.0881054,12z"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-stone border border-stone-dark text-charcoal-muted hover:bg-forest hover:text-white hover:border-forest transition-colors cursor-pointer"
              >
                <i className="ri-google-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-serif text-lg font-semibold text-charcoal mb-5">Our Services</h3>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.href}>
                  <Link
                    to={s.href}
                    className="text-charcoal-muted text-sm hover:text-forest transition-colors flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-gold text-xs"></i>
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
            <h3 className="font-serif text-lg font-semibold text-charcoal mt-8 mb-5">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-charcoal-muted text-sm hover:text-forest transition-colors flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-gold text-xs"></i>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="font-serif text-lg font-semibold text-charcoal mb-5">Areas We Serve</h3>
            <ul className="space-y-3">
              {serviceAreas.map((a) => (
                <li key={a.slug}>
                  <Link
                    to={`/service-areas#${a.slug}`}
                    className="text-charcoal-muted text-sm hover:text-forest transition-colors flex items-center gap-2"
                  >
                    <i className="ri-map-pin-line text-gold text-xs"></i>
                    {a.city}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-serif text-lg font-semibold text-charcoal mb-5">Reach Out Today</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-fill text-gold mt-0.5"></i>
                <div>
                  <p className="text-charcoal-muted text-xs uppercase tracking-widest mb-0.5">Office</p>
                  <a href="tel:3863014399" className="text-charcoal text-sm font-medium hover:text-forest transition-colors whitespace-nowrap">
                    (386) 301-4399
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-fill text-gold mt-0.5"></i>
                <div>
                  <p className="text-charcoal-muted text-xs uppercase tracking-widest mb-0.5">Phone</p>
                  <a href="tel:3865668781" className="text-charcoal text-sm font-medium hover:text-forest transition-colors whitespace-nowrap">
                    (386) 566-8781
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-fill text-gold mt-0.5"></i>
                <div>
                  <p className="text-charcoal-muted text-xs uppercase tracking-widest mb-0.5">Email</p>
                  <a href="mailto:dippelsoutdoor@gmail.com" className="text-charcoal text-sm font-medium hover:text-forest transition-colors">
                    dippelsoutdoor@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-fill text-gold mt-0.5"></i>
                <div>
                  <p className="text-charcoal-muted text-xs uppercase tracking-widest mb-0.5">Hours</p>
                  <p className="text-charcoal text-sm">Mon–Fri: 9:00 AM – 3:00 PM</p>
                  <p className="text-charcoal text-sm">Saturday: By Appointment</p>
                  <p className="text-charcoal-muted text-sm">Sunday: Closed</p>
                </div>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-6 inline-block bg-charcoal text-white text-sm font-semibold px-6 py-3 rounded-full hover:bg-forest transition-colors whitespace-nowrap"
            >
              Get a Free Estimate
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-stone-dark py-5 px-6 bg-stone">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-charcoal-muted text-sm">
            &copy; 2026 Dippel&apos;s Outdoor Services. All Rights Reserved.
          </p>
          <p className="text-charcoal-muted text-sm">
            Serving Palm Coast &middot; Ormond Beach &middot; Daytona Beach &middot; Port Orange &middot; New Smyrna Beach &middot; Edgewater, FL
          </p>
        </div>
      </div>
    </footer>
  );
}
